/**
 * © 2025 Indikin.online. All rights reserved.
 * Made with ❤️ by YalaCoder.
 *
 * Firebase Service Initialization
 *
 * - REFACTOR (V100 - Lazy Load Firestore):
 *   Removed static Firestore imports to reduce initial bundle size.
 *   Only Auth is initialized immediately.
 */
import { initializeApp } from 'firebase/app';
// import { initializeAuth, browserLocalPersistence } from 'firebase/auth'; // Removed static import

// Your web app's Firebase configuration pulled from environment variables.
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export Firebase Auth lazily
let authPromise = null;

export const getLazyAuth = () => {
  if (!authPromise) {
    authPromise = (async () => {
      const { getAuth, setPersistence, browserLocalPersistence } = await import('firebase/auth');
      const auth = getAuth(app);
      await setPersistence(auth, browserLocalPersistence);
      return auth;
    })();
  }
  return authPromise;
};

// NOTE: Firestore is no longer exported here. 
// Use the `getDb()` function from `@/services/firestore` to lazily load it.

export default app;
